/**
 * Interim shims over the unified host query API. Relays are hosts; every hook here delegates to the
 * host equivalent with {@link RELAY_FILTER} merged in, so all reads and writes share the single
 * `hostQueryKeys` cache namespace. Each shim is deleted together with its last caller when the
 * relay screens merge into the hosts screens.
 */
import { hostsCountQueryOptions, makeHostsQueryOptions, useSuspenseHostQuery } from '#api/hosts.queries.ts';
import { RELAY_FILTER, type GetHostsFilter } from '#api/hosts.ts';

/** Interim shim — use {@link useSuspenseHostQuery} — relay details are host details. */
export function useSuspenseRelayQuery(relayId: string) {
  return useSuspenseHostQuery(relayId);
}

/** Interim shim — use {@link makeHostsQueryOptions} with {@link RELAY_FILTER}. */
export const makeRelaysQueryOptions = (cursor?: string, pageSize?: number, filter?: GetHostsFilter) =>
  makeHostsQueryOptions(cursor, pageSize, { ...filter, ...RELAY_FILTER });

/** Interim shim — use {@link hostsCountQueryOptions} with {@link RELAY_FILTER}. */
export const relayCountQueryOptions = (filter: GetHostsFilter = {}) =>
  hostsCountQueryOptions({ ...filter, ...RELAY_FILTER });
